import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type DealerMarketDataFragment = (
  { __typename: 'DealershipMarket' }
  & Pick<SchemaTypes.DealershipMarket, 'defaultValue' | 'editable'>
  & { overrides: Array<(
    { __typename: 'DealershipMarketOverride' }
    & Pick<SchemaTypes.DealershipMarketOverride, 'dealerId' | 'editable' | 'value'>
  )> }
);

export const DealerMarketDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DealerMarketData on DealershipMarket {
  defaultValue
  editable
  overrides {
    dealerId
    editable
    value
  }
}
    `;